import { type FC } from 'react'
import classNames from 'classnames'

interface TemplateButtonProps {
  name: string
  disabled?: boolean
  onClick?: () => void
  truncate?: boolean
  className?: string
}

export const TemplateButton: FC<TemplateButtonProps> = ({ name, disabled = false, onClick, truncate = false, className }) => (
  <button
    type='button'
    disabled={disabled}
    onClick={onClick}
    title={truncate ? name : undefined}
    className={classNames(
      'd-flex align-items-center zocks-gap-0.375 zocks-py-0.25 px-2 border rounded-2 text-start zocks-border-color-gray-500 zocks-bg-color-white zocks-text-gray-900 paragraph-medium fw-semibold',
      { 'opacity-50': disabled, 'mw-100': truncate },
      className,
    )}
  >
    <i className='bi bi-file-earmark' aria-hidden='true' />
    {truncate ? <span className='text-truncate'>{name}</span> : name}
  </button>
)
